import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-68d55145")

_pushScopeId("data-v-68d55145")
const _hoisted_1 = { class: "ui__swiper_main" }
const _hoisted_2 = { class: "swiper-container" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "swiper-zoom-container" }
const _hoisted_5 = { class: "ui__swiper_bottomMsg" }
const _hoisted_6 = { class: "ui__swiper_leftBottom" }
const _hoisted_7 = { class: "ui__swiper_rightBottom" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.imgList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "swiper-slide",
            key: item.photoIdStr
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("img", {
                src: item.smallPhotoUrl ? _ctx.urlConversion(item.smallPhotoUrl) : _ctx.urlConversion(item.photoPath)
              }, null, 8, ["src"])
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("div", _hoisted_6, [
        _createVNode("span", null, _toDisplayString(_ctx.state.photoName), 1)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("span", null, _toDisplayString(_ctx.state.slideIndex + 1) + "/" + _toDisplayString(_ctx.state.imgList.length), 1)
      ])
    ])
  ]))
})